import { put, takeLatest, takeEvery } from 'redux-saga/effects';

import { sagaErrorDispatcher, sagaCallService } from 'Helpers';
import reportsServices from './services';
import reportsActions from './actions';
import ReportTypes from './types';

function* getTransactionCoupons(action) {
	try {
		let response = yield sagaCallService(
			reportsServices.getCouponTransactions,
			action,
			action.payload
		);
		yield put(reportsActions.couponTransactionsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			reportsActions.couponTransactionsFailure
		);
	}
}

function* getCouponsTransactionsOverview(action) {
	try {
		let response = yield sagaCallService(
			reportsServices.getCouponTransactionsOverview,
			action,
			action.payload
		);
		yield put(reportsActions.couponTransactionsOverviewSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			reportsActions.couponTransactionsOverviewFailure
		);
	}
}

function* getPaymentRequestTransactions(action) {
	try {
		let response = yield sagaCallService(
			reportsServices.getPaymentRequestTransactions,
			action,
			action.payload
		);
		yield put(reportsActions.paymentRequestTransactionsSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			reportsActions.paymentRequestTransactionsFailure
		);
	}
}

function* getPaymentRequestTransactionsOverview(action) {
	try {
		let response = yield sagaCallService(
			reportsServices.getPaymentRequestTransactionsOverview,
			action,
			action.payload
		);
		yield put(
			reportsActions.paymentRequestTransactionsOverviewSuccess(response.data)
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			reportsActions.paymentRequestTransactionsOverviewFailure
		);
	}
}

function* getTransactionPackageList(action) {
	try {
		let response = yield sagaCallService(
			reportsServices.getTransactionPackage,
			action,
			action.payload
		);
		yield put(reportsActions.ReportTransactionsPackageSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			reportsActions.ReportTransactionsPackageFailure
		);
	}
}
function* getChartPackageList(action) {
	try {
		let response = yield sagaCallService(
			reportsServices.getChartPackage,
			action,
			action.payload
		);
		yield put(reportsActions.ReportChartPackageSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			reportsActions.ReportChartPackageFailure
		);
	}
}
function* getChartPackageOffcbList(action) {
	try {
		let response = yield sagaCallService(
			reportsServices.getChartPackageOffcb,
			action,
			action.payload
		);
		yield put(reportsActions.ReportChartPackageOffcbSuccess(response.data));
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			reportsActions.ReportChartPackageOffcbFailure
		);
	}
}
function* getTransactionPackageOffcbList(action) {
	try {
		let response = yield sagaCallService(
			reportsServices.getTransactionPackageOffcb,
			action,
			action.payload
		);
		yield put(
			reportsActions.ReportTransactionsPackageOffcbSuccess(response?.data)
		);
	} catch (e) {
		yield sagaErrorDispatcher(
			e,
			action,
			reportsActions.ReportTransactionsPackageOffcbFailure
		);
	}
}

const reportsSagas = [
	takeLatest(ReportTypes.COUPON_TRANSACTIONS.REQUEST, getTransactionCoupons),
	takeLatest(
		ReportTypes.COUPONS_TRANSACTIONS_OVERVIEW.REQUEST,
		getCouponsTransactionsOverview
	),
	takeLatest(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW.REQUEST,
		getPaymentRequestTransactionsOverview
	),
	takeLatest(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS.REQUEST,
		getPaymentRequestTransactions
	),
	takeLatest(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE.REQUEST,
		getTransactionPackageList
	),
	takeLatest(ReportTypes.REPORT_CHART_PACKAGE.REQUEST, getChartPackageList),
	takeLatest(
		ReportTypes.REPORT_CHART_PACKAGE_OFFCB.REQUEST,
		getChartPackageOffcbList
	),
	takeEvery(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE_OFFCB.REQUEST,
		getTransactionPackageOffcbList
	),
];

export default reportsSagas;
